// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-bar":"YMsGS","rc-tabs-tab":"Z-1nH","rc-tabs-tab-active":"P+iLD","tip":"YEEzm","tip-label":"wJVd9","tip-group":"Y9XkK","option":"e8W+K","option-title":"_3BZUZ"};